export const appBaseUrl = "/"

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"بازی کن و ۵ سوت طلا جایزه ببر!"},{"property":"og:url","content":"http://staging.taline-shell-game.hhaa.io"},{"property":"og:type","content":"website"},{"property":"og:title","content":"طلاگردون طلاین"},{"property":"og:description","content":"بازی کن و ۵ سوت طلا جایزه ببر!"}],"link":[],"style":[],"script":[],"noscript":[],"title":"طلاگردون طلاین","charset":"utf-8"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnUrl = ""

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'